import React from 'react';
import { styled } from '@mui/system';
import { ConvertCard } from '@datatox-bi/util';
import { Grid, Card, Typography, Box } from '@mui/material';
import Description from '../Title/Description';

const getCardLayout = (layout, theme) => {
    switch (layout) {
        case 'moderno':
            return {
                backgroundColor: '#00B0FF',
                color: '#FFFFFF',
            };
        case 'dark':
            return {
                backgroundColor: '#263238',
                color: '#FFC107',
            };
        case 'natural':
            return {
                backgroundColor: '#4CAF50',
                color: '#FFFFFF',
            };
        case 'luxuoso':
            return {
                backgroundColor: '#795548',
                color: '#BDBDBD',
            };
        case 'oceano':
            return {
                backgroundColor: '#0D47A1',
                color: '#FFFFFF',
            };
        case 'sol':
            return {
                backgroundColor: '#E65100',
                color: '#FFFFFF',
            };
        case 'esmeralda':
            return {
                backgroundColor: '#00695C',
                color: '#FFFFFF',
            };
        case 'ametista':
            return {
                backgroundColor: '#4A148C',
                color: '#FFFFFF',
            };
        default:
            return {
                backgroundColor: layout,
                color: '#fff'
            };
    }
};

const CardRoot = styled(Card)(({ theme, layout = 'sol' }) => ({
    height: 150,
    ...getCardLayout(layout, theme),
}));

const Num = styled(Typography)(({ theme }) => ({
    fontSize: '3.0rem',
    fontWeight: 'bold',
}));

const Paragraph = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(1),
    fontSize: '1.3rem',
    lineHeight: '1',
}));

function CardChart({ title, children, subtitle, description, layout = 'sol' }) {
    return (
        <CardRoot layout={layout}>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                <Grid container spacing={1} direction="column" alignItems="center">
                    <Num variant="h4" component="h4">
                        {children}
                    </Num>
                    {subtitle !== undefined && (
                        <Typography variant="h6" component="h6" style={{ marginTop: '-10px', padding: 0 }}>
                            ({subtitle})
                        </Typography>
                    )}
                    <Paragraph component="p" align="center">
                        {title}
                        {description && <Description>{description}</Description>}
                    </Paragraph>
                </Grid>
            </Box>
        </CardRoot>
    );
}

export function CardAbsoluteChart({ datasetDruid, title, subtitle, having, description, layout }) {
    return (
        <CardChart title={title} description={description} subtitle={subtitle} layout={layout} sx={{width: '100%'}}>
            {ConvertCard.toValorAbsoluto([...datasetDruid], having)}
        </CardChart>
    );
}

export function CardPercentageChart({ datasetDruid, title, having, enableAbsoluteValue, description, layout }) {
    return (
        <CardChart
            title={title}
            description={description}
            subtitle={enableAbsoluteValue && ConvertCard.toValorAbsoluto([...datasetDruid], having)}
            layout={layout}
        >
            {ConvertCard.toPorcentagem([...datasetDruid], having)}
        </CardChart>
    );
}

export function CardPercentage2Chart({ datasetDruid, title, having, description, layout }) {
    return (
        <CardChart title={title} description={description} subtitle={ConvertCard.toValorAbsoluto([...datasetDruid], having)} layout={layout}>
            {ConvertCard.toPorcentagem([...datasetDruid], having)}
        </CardChart>
    );
}

export function CardAverageChart({ datasetDruid, title, description, layout }) {
    return (
        <CardChart title={title} description={description} layout={layout}>
            {ConvertCard.toAverage([...datasetDruid])}
        </CardChart>
    );
}

export function CardDistinctCountChart({ datasetDruid, title, description, layout }) {
    return (
        <CardChart title={title} description={description} layout={layout}>
            {ConvertCard.toDistincCount([...datasetDruid])}
        </CardChart>
    );
}
